import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { TextFormat, Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './service-order.reducer';

export const ServiceOrder = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(
    overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search),
  );

  const serviceOrderList = useAppSelector(state => state.serviceOrder.entities);
  const loading = useAppSelector(state => state.serviceOrder.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="service-order-heading" data-cy="ServiceOrderHeading">
        <Translate contentKey="crawlerBackendApp.serviceOrder.home.title">Service Orders</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="crawlerBackendApp.serviceOrder.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/service-order/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="crawlerBackendApp.serviceOrder.home.createLabel">Create new Service Order</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {serviceOrderList && serviceOrderList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="crawlerBackendApp.serviceOrder.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('startDate')}>
                  <Translate contentKey="crawlerBackendApp.serviceOrder.startDate">Start Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('startDate')} />
                </th>
                <th className="hand" onClick={sort('endDate')}>
                  <Translate contentKey="crawlerBackendApp.serviceOrder.endDate">End Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('endDate')} />
                </th>
                <th className="hand" onClick={sort('serviceStatus')}>
                  <Translate contentKey="crawlerBackendApp.serviceOrder.serviceStatus">Service Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('serviceStatus')} />
                </th>
                <th className="hand" onClick={sort('createdTimestamp')}>
                  <Translate contentKey="crawlerBackendApp.serviceOrder.createdTimestamp">Created Timestamp</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdTimestamp')} />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.serviceOrder.productOrder">Product Order</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {serviceOrderList.map((serviceOrder, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/service-order/${serviceOrder.id}`} color="link" size="sm">
                      {serviceOrder.id}
                    </Button>
                  </td>
                  <td>
                    {serviceOrder.startDate ? (
                      <TextFormat type="date" value={serviceOrder.startDate} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {serviceOrder.endDate ? (
                      <TextFormat type="date" value={serviceOrder.endDate} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.ServiceStatus.${serviceOrder.serviceStatus}`} />
                  </td>
                  <td>
                    {serviceOrder.createdTimestamp ? (
                      <TextFormat type="date" value={serviceOrder.createdTimestamp} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {serviceOrder.productOrder ? (
                      <Link to={`/product-order/${serviceOrder.productOrder.id}`}>{serviceOrder.productOrder.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/service-order/${serviceOrder.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/service-order/${serviceOrder.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() => (window.location.href = `/service-order/${serviceOrder.id}/delete`)}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="crawlerBackendApp.serviceOrder.home.notFound">No Service Orders found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ServiceOrder;
